/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOOutletTransactionSummaryDTO } from '../models/ApiResponseDTOOutletTransactionSummaryDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OutletSummaryApiService {

    /**
     * Transaction summary, for one outlet or the whole merchant
     * The same figures as the per-outlet summary, with outletId as an optional query parameter. Omit it and every outlet the caller owns is totalled together; the per-outlet path remains for callers already using it.
     * @param outletId
     * @param period
     * @param startDate
     * @param endDate
     * @returns ApiResponseDTOOutletTransactionSummaryDTO Summary retrieved successfully
     * @throws ApiError
     */
    public static getOutletSummaryFiltered(
        outletId?: string,
        period: 'TODAY' | 'CURRENT_WEEK' | 'CURRENT_MONTH' | 'CURRENT_YEAR' | 'CUSTOM' = 'TODAY',
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<ApiResponseDTOOutletTransactionSummaryDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/outlets/summary',
            query: {
                'outletId': outletId,
                'period': period,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Invalid period or date range`,
                401: `Unauthorized`,
                403: `Access denied for requested outlet ID`,
                404: `Outlet not found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

    /**
     * Get an outlet's transaction summary
     * Transaction count and volume for an outlet over a reporting period, split by payment method. Every payment method is returned, zero-filled where the outlet took nothing. Only successful collections are counted: charges, refunds and outward transfers are excluded. startDate and endDate apply to the CUSTOM period only. Access is checked against the outlet, so a caller who may not see it is refused.
     * @param outletId
     * @param period
     * @param startDate
     * @param endDate
     * @returns ApiResponseDTOOutletTransactionSummaryDTO Summary retrieved successfully
     * @throws ApiError
     */
    public static getOutletSummary(
        outletId: string,
        period: 'TODAY' | 'CURRENT_WEEK' | 'CURRENT_MONTH' | 'CURRENT_YEAR' | 'CUSTOM' = 'TODAY',
        startDate?: string,
        endDate?: string,
    ): CancelablePromise<ApiResponseDTOOutletTransactionSummaryDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operation/outlets/{outletId}/summary',
            path: {
                'outletId': outletId,
            },
            query: {
                'period': period,
                'startDate': startDate,
                'endDate': endDate,
            },
            errors: {
                400: `Invalid period or date range`,
                401: `Unauthorized`,
                403: `Forbidden - no access to this outlet`,
                404: `Outlet not found`,
                500: `Internal server error`,
                501: `Not Implemented`,
                503: `Service Unavailable`,
            },
        });
    }

}
